<template>
  <ModalLayout :size="'sm'">
    <template #header>{{ $t('REMOVE_MODAL.TITLE') }}</template>
    <template #body>
      <div class="c-remove-modal">
        <p class="c-remove-modal__message">{{ $t('REMOVE_MODAL.MESSAGE') }}</p>
        <div class="c-remove-modal__buttons">
          <button class="btn btn-cancel-outline c-remove-modal__button" @click="close">
            {{ $t('REMOVE_MODAL.ABORT') }}
          </button>
          <button class="btn btn-secondary c-remove-modal__button c-remove-modal__button--active" @click="onRemove">
            {{ $t('REMOVE_MODAL.DELETE') }}
          </button>
        </div>
      </div>
    </template>
  </ModalLayout>
</template>

<script lang="ts" setup>
import ModalLayout from '@/components/layout/modal/ModalLayout.vue';
import useModal from '@/services/useModal';

const emit = defineEmits<{
  remove: [];
}>();

const { close } = useModal();

const onRemove = () => {
  emit('remove');
  close();
};
</script>
